import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { HocNavigationComponent } from './navigation/hoc-navigation.component';
import { NgxTranslateModule } from '@modules/translate/translate.module';
import { MapComponent } from './map/map.component';
import { EbcontGalaxyModule } from '@ebcont/ebcont.galaxy.js';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HocGroupedListComponent } from './hoc-grouped-list';
import { CoreModule } from '@core/core.module';
import { HocAccessDeniedComponent } from './hoc-access-denied/hoc-access-denied.component';
import { HocPersonCardComponent } from '@hoc/person-card/hoc-person-card.component';
import { HocUserMenuComponent } from '@hoc/hoc-user-menu/hoc-user-menu.component';
import { HocProfileImageComponent } from './hoc-image/hoc-profile-image.component';
import { HocFilterBlockComponent } from '@hoc/hoc-filter-block/hoc-filter-block.component';
import { HocDownloadStatusComponent } from '@hoc/hoc-download-status/hoc-download-status.component';
import { HocProfileDownloadComponent } from './person-card/hoc-profile-download/hoc-profile-download.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HocProfileDownloadFormComponent } from '@hoc/person-card/hoc-profile-download/hoc-profile-download-form/hoc-profile-download-form.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";

//const HOC_MODULES: NgModule['declarations'] & NgModule['exports'] = [

const ReusableComponents = [
  HocNavigationComponent,
  HocGroupedListComponent,
  MapComponent,
  HocAccessDeniedComponent,
  HocPersonCardComponent,
  HocUserMenuComponent,
  HocProfileImageComponent,
  HocFilterBlockComponent,
  HocDownloadStatusComponent,
  HocProfileDownloadComponent,
  HocProfileDownloadFormComponent
];
@NgModule({
  declarations: [...ReusableComponents],
  exports: [...ReusableComponents],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    //BrowserModule,
    //BrowserAnimationsModule,
    FontAwesomeModule,
    RouterModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    EbcontGalaxyModule,
    NgxTranslateModule,
    CoreModule,
    OverlayModule,
    PortalModule,
    TooltipComponent
  ]
})
export class HocModule {}
